/**
 * Applies primary color to hero text blocks containing "FUND THE FIGHT"
 */
const initHeroTextColor = () => {
  const heroSection = document.querySelector('.hero-wrapper');
  if (!heroSection) return;

  const textBlocks = heroSection.querySelectorAll('.text-block');

  for (const block of textBlocks) {
    if (!(block instanceof HTMLElement)) continue;
    if (block.dataset.heroTextProcessed) continue;

    const text = block.textContent;
    if (text && text.includes('FUND THE FIGHT')) {
      block.style.color = 'var(--color-primary)';
      const allChildren = block.querySelectorAll('*');

      for (const child of allChildren) {
        if (child instanceof HTMLElement) {
          child.style.color = 'var(--color-primary)';
        }
      }
    }

    block.dataset.heroTextProcessed = 'true';
  }
};

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initHeroTextColor);
} else {
  initHeroTextColor();
}

// Also initialize for dynamically added content (e.g., section hydration)
document.addEventListener('section:hydrated', initHeroTextColor);
